import React from "react";
import "../forcss/card.css"

import Header from '../components/Header';
import Carousel from '../components/Carousel';
import Footer from '../components/footer';
import { Link } from 'react-router-dom';
import Courses from '../components/coursess';

const Home = () => {


  return (
    <div className='all'>
    <div className="container">
      <Header/>
      <main>
        <div className="big-card">
          <div className="side1">
            <p >Ilyosbek onlayn ta’lim platformasi</p>
    <h1>Dasturlashga oid <br />kasblarni o`rgatamiz</h1>
    <Link to={"/enroll"}><button>Explore</button></Link>
          </div>

          <div className="side2">
<img src="/vector.png" alt="" />
          </div>
        </div>

        <div className="results">
          <div className="part1"><h1>Istalgan joyda, o’zingizga qulay vaqtda o’qish imkoniyati</h1></div>
          <div className="info"><h2>50+</h2>
          <p>Jami tahsil olayotgan o’quvchilarimiz</p>
          </div>
          <div className="info"><h2>50+</h2>
          <p>Jami tahsil olayotgan o’quvchilarimiz</p>
          </div>
          <div className="info"><h2>50+</h2>
          <p>Jami tahsil olayotgan o’quvchilarimiz</p>
          </div>
        </div>
        <h1 className='alohida'>Kurslarimiz</h1>
        <div className="kurslar">
          <Courses/>
          <Link to={"/learn"}><button>see more</button></Link>
        </div>
        

      </main>
    </div>
    <h1 className='alohida'>Hamkorlarimiz</h1>
    <Carousel/>
    <Footer/>
    </div>
  )
}

export default Home